module.exports = __webpack_public_path__ + "static/media/Nota NFL alitas caseras.5c7f2ed5.webp";